var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFD88D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.84 38.4C30.4933 38.4 28.4 37.88 26.56 36.84C24.7467 35.8 23.3333 34.2667 22.32 32.24C21.3067 30.2133 20.8 27.7467 20.8 24.84C20.8 21.9867 21.3333 19.5467 22.4 17.52C23.4667 15.4933 24.9867 13.9333 26.96 12.84C28.96 11.7467 31.3067 11.2 34 11.2C36.9867 11.2 39.4 11.7467 41.24 12.84C43.08 13.9067 44.5067 15.6133 45.52 17.96L39.16 20.48C38.8133 19.12 38.2 18.1333 37.32 17.52C36.44 16.9067 35.3467 16.6 34.04 16.6C32.7333 16.6 31.6133 16.92 30.68 17.56C29.7467 18.1733 29.04 19.0933 28.56 20.32C28.08 21.52 27.84 23.0133 27.84 24.8C27.84 26.6667 28.08 28.2267 28.56 29.48C29.0667 30.7333 29.8 31.6667 30.76 32.28C31.7467 32.8667 32.96 33.16 34.4 33.16C35.1733 33.16 35.88 33.0667 36.52 32.88C37.16 32.6933 37.72 32.4267 38.2 32.08C38.68 31.7067 39.0533 31.2533 39.32 30.72C39.5867 30.16 39.72 29.5067 39.72 28.76V28.36H33.68V23.76H45.56V38H40.88L40.36 31.8L41.48 32.76C40.92 34.5733 39.9067 35.9733 38.44 36.96C37 37.92 35.1333 38.4 32.84 38.4Z",
    fill: "#0E0E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHalf);
export default __webpack_public_path__ + "static/media/logoHalf.601674d6c37109885cf77b8961105f2e.svg";
export { ForwardRef as ReactComponent };